import { DashboardBanner } from '@components/features/organisms/DashboardBanner';
import { lazyWithReload } from '@shared/react/lazyWithReload';
import { PermissionGuard } from '@shared/router';
import { Route } from 'react-router-dom';

import { dashboardPath, pendingActionsPath } from './urls';

const DashboardView = lazyWithReload(() =>
  import('./pages/Dashboard').then((m) => ({ default: m.DashboardContainer }))
);

const PendingActionsView = lazyWithReload(() =>
  import('./pages/PendingActions').then((m) => ({ default: m.PendingActionsContainer }))
);

export const DashboardRoutes = (
  <>
    <Route
      path={dashboardPath}
      element={
        <PermissionGuard>
          <DashboardBanner>
            <DashboardView />
          </DashboardBanner>
        </PermissionGuard>
      }
    />
    <Route
      path={pendingActionsPath}
      element={
        <PermissionGuard>
          <PendingActionsView />
        </PermissionGuard>
      }
    />
  </>
);
